







import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({})
export default class ShareMod extends Vue {
  @Prop() close: () => void
}
